// gatsby-browser.js
import "./src/styles/global.css";
import "./src/styles/print.css";
import React from "react";
// import RootProviders from "./src/components/RootProviders";
import RootProviders from "./src/context/RootProviders";

export const wrapRootElement = ({ element }) => (
  <RootProviders>{element}</RootProviders>
);
